export const useQuery = () => new URLSearchParams(window.location.search)